/**
 * Csv Schema of RelatorioGeracao
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {RelatorioGeracao} from '@/model/resource/RelatorioGeracao'

/* TODO: review generated schema */
export class CsvRelatorioGeracaoSchema extends Schema {
  readonly name = 'CsvRelatorioGeracao'

  readonly fieldSet: FieldSet<RelatorioGeracao> = {
    idRelatorioGeracaoPk: schema => schema.model.idRelatorioGeracaoPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    tipoRelatorio: schema => schema.model.tipoRelatorio?.$id ?? null,
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
    urlDownload: schema => schema.model.urlDownload,
    dataGeracaoRelatorio: schema =>
      Helper.datetime(schema.model.dataGeracaoRelatorio),
  }
}
